export const tenantTypeEnum = [
    {
        stateId: "STORE",
        stateName: "驿站"
    },
    {
        stateId: "ONLINE_STORE",
        stateName: "网店"
    },
    {
        stateId: "CLUB",
        stateName: "俱乐部"
    },
    {
        stateId: "VENUE",
        stateName: "场地"
    },
    {
        stateId: "BIKE_STORE",
        stateName: "车店"
    },
    {
        stateId: "THERAPIST_STORE",
        stateName: "理疗师"
    },
    {
        stateId: "PHOTOGRAPHY_STORE",
        stateName: "摄影师"
    },
    {
        stateId: "BRAND",
        stateName: "品牌方"
    }
]
